export default __webpack_public_path__ + "images/offer.svg?9791a9a386ceb2314871193d54e50978";